import request from '@/utils/request'


// 查询设备信息列表
export function listDevice(query) {
  return request({
    url: '/tram/tram-device/list',
    method: 'get',
    params: query
  })
}

// 查询设备信息分页
export function pageDevice(query) {
  return request({
    url: '/tram/tram-device/page',
    method: 'get',
    params: query
  })
}

// 查询设备信息详细
export function getDevice(data) {
  return request({
    url: '/tram/tram-device/detail',
    method: 'get',
    params: data
  })
}

// 新增设备信息
export function addDevice(data) {
  return request({
    url: '/tram/tram-device/add',
    method: 'post',
    data: data
  })
}

// 修改设备信息
export function updateDevice(data) {
  return request({
    url: '/tram/tram-device/edit',
    method: 'post',
    data: data
  })
}

// 删除设备信息
export function delDevice(data) {
  return request({
    url: '/tram/tram-device/delete',
    method: 'post',
    data: data
  })
}



// 查询设备信息详细
export function importData(data) {
  return request({
    url: 'tram/tram-config/import/config',
    method: 'post',
    data
  })
}
